import React from 'react';
import { useParams } from 'react-router';
import Loader from 'react-spinners/ScaleLoader';
import useClinicWithTreatments from './hooks/useClinicWithTreatments';
import ModifyClinic from './components/ModifyClinic';

type RouteParams = {
  clinicId: string;
};

const ModifyClinicContainer = () => {
  const { clinicId } = useParams<RouteParams>();
  const { clinic, isLoading } = useClinicWithTreatments(clinicId);

  if (isLoading) {
    return <Loader />;
  }

  if (!clinic) {
    return <div>Couldn't fetch clinic</div>;
  }

  return <ModifyClinic clinic={clinic} />;
};

export default ModifyClinicContainer;
